import type { Subcategory } from '~/entities/categories'
import { getFacetOptions } from './get-facet-options'

export function getPossibleReasons({
  phase,
  outcome,
  subcategories,
}: {
  phase: string
  outcome?: string
  subcategories: Subcategory[]
}) {
  return getFacetOptions({
    subcategories: subcategories.filter(
      ({ metadata }) =>
        metadata.phase.label === phase && (!outcome || metadata.outcome.label === outcome),
    ),
    selectFacet: ({ metadata }) => metadata.reason,
  })
}
